import { RootState } from '../../store';

export const getRulesSelector = (state: RootState) => state?.ruleReducer?.rules;
